import { setUrlParams } from '../utils/url';
import { create } from '../utils/create';
export class Controller {
    constructor(model) {
        // data (main)
        this.setData = (data) => {
            const state = this.model.getState();
            this.model.setState(Object.assign(Object.assign({}, state), { products: data, productsToShow: data, namesToShow: data }));
        };
        this.clearData = () => {
            const state = this.model.getState();
            const params = {};
            setUrlParams(params);
            localStorage.clear();
            this.model.setState(Object.assign(Object.assign({}, state), { productsToShow: state.products, categoryFilters: [], nameFilters: [], sort: '', search: '' }));
        };
        // FILTERS (by Category) (filter page)
        this.setFilterByCategory = (category, enabled = false) => {
            if (enabled) {
                this.addFilterByCategory(category);
                return;
            }
            this.removeFilterByCategory(category);
        };
        this.removeFilterByCategory = (category) => {
            const state = this.model.getState();
            const categoryFilters = state.categoryFilters.filter((cat) => cat !== category);
            this.model.setState(Object.assign(Object.assign({}, state), { categoryFilters }));
            this.prepareProductsToShow();
        };
        this.addFilterByCategory = (category) => {
            const state = this.model.getState();
            const categoryFilters = [...state.categoryFilters, category];
            this.model.setState(Object.assign(Object.assign({}, state), { categoryFilters }));
            this.prepareProductsToShow();
        };
        // FILTERS (by Name) (filter page)
        this.setFilterByName = (name, enabled = false) => {
            if (enabled) {
                this.addFilterByName(name);
                return;
            }
            this.removeFilterByName(name);
        };
        this.removeFilterByName = (name) => {
            const state = this.model.getState();
            const nameFilters = state.nameFilters.filter((itemName) => itemName !== name);
            this.model.setState(Object.assign(Object.assign({}, state), { nameFilters }));
            this.prepareProductsToShow();
        };
        this.addFilterByName = (name) => {
            const state = this.model.getState();
            const nameFilters = [...state.nameFilters, name];
            this.model.setState(Object.assign(Object.assign({}, state), { nameFilters }));
            this.prepareProductsToShow();
        };
        // ProductsToShow (filter page)
        this.prepareProductsToShow = () => {
            const state = this.model.getState();
            const url = window.location.pathname;
            const categoryFilters = [...state.categoryFilters];
            const nameFilters = [...state.nameFilters];
            const sort = state.sort;
            const search = state.search;
            const view = state.view;
            let products = [...state.products];
            const params = {};
            if (categoryFilters.length) {
                params.categoryFilters = categoryFilters;
                products = products.filter(({ category }) => categoryFilters.includes(category));
            }
            if (nameFilters.length) {
                params.nameFilters = nameFilters;
                products = products.filter(({ animeName }) => nameFilters.includes(animeName));
            }
            if (sort.length) {
                params.sort = [sort];
                switch (sort) {
                    case 'chaepAtFirst':
                        products = products.sort((a, b) => (a.price > b.price ? 1 : -1));
                        break;
                    case 'expensiveFirst':
                        products = products.sort((a, b) => (b.price > a.price ? 1 : -1));
                        break;
                    case 'MoreInStock':
                        products = products.sort((a, b) => (b.stock > a.stock ? 1 : -1));
                        break;
                    case 'LessInStock':
                        products = products.sort((a, b) => (a.stock > b.stock ? 1 : -1));
                        break;
                    default:
                        break;
                }
            }
            if (search.length) {
                params.search = [search];
                products = products.filter(({ name, description, price, animeName, category, popularity, stock }) => {
                    const nameStr = name.toLocaleLowerCase();
                    const descriptionStr = description.toLocaleLowerCase();
                    const animeNameStr = animeName.toLocaleLowerCase();
                    const categoryStr = category.toLocaleLowerCase();
                    const stockStr = stock.toString();
                    const priceStr = price.toString();
                    const popularityStr = popularity.toString();
                    const searchStr = search.toLocaleLowerCase();
                    return (nameStr.match(searchStr) ||
                        stockStr.match(searchStr) ||
                        descriptionStr.match(searchStr) ||
                        animeNameStr.match(searchStr) ||
                        categoryStr.match(searchStr) ||
                        priceStr.match(searchStr) ||
                        popularityStr.match(searchStr));
                });
            }
            if (view.length) {
                params.view = [view];
            }
            if (url === '/filter') {
                setUrlParams(params);
            }
            this.model.setState(Object.assign(Object.assign({}, state), { productsToShow: products }));
        };
        // POPUP
        this.setPopup = (popup) => {
            this.popup = popup;
        };
        this.openPopup = () => {
            var _a, _b, _c, _d;
            (_b = (_a = this.popup) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.classList.add('active');
            (_d = (_c = this.popup) === null || _c === void 0 ? void 0 : _c.popupContent) === null || _d === void 0 ? void 0 : _d.classList.add('active');
        };
        this.closePopup = () => {
            var _a, _b, _c, _d;
            (_b = (_a = this.popup) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.classList.remove('active');
            (_d = (_c = this.popup) === null || _c === void 0 ? void 0 : _c.popupContent) === null || _d === void 0 ? void 0 : _d.classList.remove('active');
        };
        this.confirmPopup = (form, cross) => {
            const confirmText = create({
                tagName: 'h2',
                classNames: 'confirm-text',
                children: `The order has been placed`
            });
            setTimeout(() => {
                var _a;
                form.innerHTML = ``;
                cross.innerHTML = ``;
                (_a = form.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(confirmText);
                setTimeout(() => {
                    window.location.pathname = '/';
                    this.cleanCart();
                }, 1100);
            }, 700);
        };
        this.cleanCart = () => {
            localStorage.clear();
        };
        // Sorting (filter page)
        this.addSorting = (str) => {
            const state = this.model.getState();
            const sort = str;
            this.model.setState(Object.assign(Object.assign({}, state), { sort }));
            this.prepareProductsToShow();
        };
        // search (filter page)
        this.addSearching = (str) => {
            const state = this.model.getState();
            const search = str;
            this.model.setState(Object.assign(Object.assign({}, state), { search }));
            this.prepareProductsToShow();
        };
        // change view  (filter page)
        this.changeView = (viewStr) => {
            const state = this.model.getState();
            const view = viewStr;
            this.model.setState(Object.assign(Object.assign({}, state), { view }));
            this.prepareProductsToShow();
        };
        // pagination
        this.isDisabled = (countOfPages, pageCounter, btnLeft, btnRight) => {
            if (pageCounter > 1) {
                btnLeft.disabled = false;
            }
            else {
                btnLeft.disabled = true;
            }
            if (countOfPages === 1 || countOfPages === pageCounter) {
                btnRight.disabled = true;
            }
            else {
                btnRight.disabled = false;
            }
        };
        this.cartQuery = (page, pageSize) => {
            const params = {};
            params.page = [`${page}`];
            params.pageSize = [`${pageSize}`];
            setUrlParams(params);
        };
        // promo
        this.removePromo = (promoWrapper, promo) => {
            promoWrapper === null || promoWrapper === void 0 ? void 0 : promoWrapper.classList.remove('input-promo-wrapper_active');
            promo === null || promo === void 0 ? void 0 : promo.classList.remove('add-promo_active');
        };
        //Cart
        this.getCurrentCartProducts = () => {
            return this.model.getState().cartProducts;
        };
        this.pushNewCartProduct = (cartProduct) => {
            const state = this.model.getState();
            const currCartProd = state.cartProducts;
            currCartProd.push(cartProduct);
            localStorage.setItem('key', JSON.stringify(currCartProd));
            this.model.setState(Object.assign(Object.assign({}, state), { cartProducts: currCartProd }));
        };
        this.removeCartProduct = (index) => {
            const state = this.model.getState();
            const currCartProd = state.cartProducts;
            currCartProd.splice(index, 1);
            localStorage.setItem('key', JSON.stringify(currCartProd));
            this.model.setState(Object.assign(Object.assign({}, state), { cartProducts: currCartProd }));
        };
        this.increaseAmountOfExistingCartProduct = (product, amountToAdd) => {
            const state = this.model.getState();
            const currCartProd = state.cartProducts;
            const found = currCartProd.find((item) => item.product.id === product.id);
            if (found !== undefined) {
                found.amount += amountToAdd;
            }
            localStorage.setItem('key', JSON.stringify(currCartProd));
            this.model.setState(Object.assign(Object.assign({}, state), { cartProducts: currCartProd }));
        };
        this.decreaseAmountOfExistingCartProduct = (product, amountToAdd) => {
            const state = this.model.getState();
            const currCartProd = state.cartProducts;
            const found = currCartProd.find((item) => item.product.id === product.id);
            const foundIndex = currCartProd.findIndex((item) => item.product.id === product.id);
            if (found !== undefined) {
                if (found.amount > 1) {
                    found.amount -= amountToAdd;
                }
                else {
                    currCartProd.splice(foundIndex, 1);
                }
            }
            localStorage.setItem('key', JSON.stringify(currCartProd));
            this.model.setState(Object.assign(Object.assign({}, state), { cartProducts: currCartProd }));
        };
        this.getCartItemsFromStorage = () => {
            const state = this.model.getState();
            const storageObject = localStorage.getItem('key');
            let currCartProd = state.cartProducts;
            if (storageObject !== null) {
                currCartProd = JSON.parse(storageObject);
            }
            this.model.setState(Object.assign(Object.assign({}, state), { cartProducts: currCartProd }));
        };
        this.model = model;
        this.popup = null;
    }
}
